import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../api_config";
import UserContext from "../../Components/Authcontext";
import Load from "../Loading/Load";
import "./modern-forms.css";

function ModernFamilyDetails() {
  const { user, token } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [father, setFather] = useState("");
  const [fcaste, setFcaste] = useState("");
  const [fkulam, setFkulam] = useState("");
  const [mother, setMother] = useState("");
  const [mcaste, setMcaste] = useState("");
  const [mkulam, setMkulam] = useState("");
  const [fstatus, setFstatus] = useState("");
  const [ftype, setFtype] = useState("");
  const [fvalues, setFvalues] = useState("");
  const [sisters, setSisters] = useState("");
  const [brothers, setBrothers] = useState("");
  const [msisters, setMsisters] = useState("");
  const [mbrothers, setMbrothers] = useState("");
  const [parentsno, setParentsno] = useState("");
  const navigate = useNavigate();

  // Define the form steps
  const totalSteps = 8;
  const currentStep = 5;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const response = await axios.post(
      `${API_BASE_URL}/api/FamilyDetails`,
      {
        user,
        father,
        fcaste,
        fkulam,
        mother,
        mcaste,
        mkulam,
        fstatus,
        ftype,
        fvalues,
        sisters,
        brothers,
        msisters,
        mbrothers,
        parentsno,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );
    if (response.data.auth) {
      setLoading(false);
      navigate("/modern-habits-info", { replace: true });
      setFather("");
      setFcaste("");
      setFkulam("");
      setMother("");
      setMcaste("");
      setMkulam("");
      setFstatus("");
      setFtype("");
      setFvalues("");
      setSisters("");
      setBrothers("");
      setMsisters("");
      setMbrothers("");
      setParentsno("");
    }
  };

  // Calculate progress percentage
  const progressPercentage = (currentStep / totalSteps) * 100;

  return loading ? (
    <Load />
  ) : (
    <div className="profile-form-container">
      <div className="decoration decoration-1"></div>
      <div className="decoration decoration-2"></div>
      <div className="decoration decoration-3"></div>
      <div className="decoration decoration-4"></div>
      <div className="profile-form-card">
        {/* Form Header with Progress Bar */}
        <div className="profile-form-header">
          <div className="progress-container">
            <div className="progress-steps">
              {Array.from({ length: totalSteps }, (_, i) => (
                <div key={i} className="progress-step">
                  <div
                    className={`step-number ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 < currentStep ? "✓" : i + 1}
                  </div>
                  <div
                    className={`step-label ${i + 1 === currentStep ? "active" : ""} ${
                      i + 1 < currentStep ? "completed" : ""
                    }`}
                  >
                    {i + 1 === 1 && "Basic Info"}
                    {i + 1 === 2 && "Contact"}
                    {i + 1 === 3 && "Personal"}
                    {i + 1 === 4 && "Photos"}
                    {i + 1 === 5 && "Family"}
                    {i + 1 === 6 && "Lifestyle"}
                    {i + 1 === 7 && "Religious"}
                    {i + 1 === 8 && "Preferences"}
                  </div>
                </div>
              ))}
              <div className="progress-line">
                <div
                  className="progress-line-fill"
                  style={{ width: `${progressPercentage}%` }}
                ></div>
              </div>
            </div>
          </div>
          <h2 className="profile-form-title">Family Details</h2>
          <p className="profile-form-subtitle">Tell us about your family</p>
          <p className="required-fields-note">All fields are mandatory</p>
        </div>

        {/* Form Body */}
        <form onSubmit={handleSubmit}>
          <div className="profile-form-body">
            <div className="form-section">
              <div className="form-section-title">Father's Information</div>
              <div className="form-row">
                <div className="form-col">
                  <div className="form-group">
                    <label className="form-label">Father's Name</label>
                    <input
                      className="form-control"
                      type="text"
                      value={father}
                      placeholder="Enter father's name"
                      onChange={(e) => setFather(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="form-col">
                  <div className="form-group">
                    <label className="form-label">Father's Caste</label>
                    <input
                      className="form-control"
                      type="text"
                      value={fcaste}
                      placeholder="Enter father's caste"
                      onChange={(e) => setFcaste(e.target.value)}
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Father's Kulam</label>
                <input
                  className="form-control"
                  type="text"
                  value={fkulam}
                  placeholder="Enter father's kulam"
                  onChange={(e) => setFkulam(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-section">
              <div className="form-section-title">Mother's Information</div>
              <div className="form-row">
                <div className="form-col">
                  <div className="form-group">
                    <label className="form-label">Mother's Name</label>
                    <input
                      className="form-control"
                      type="text"
                      value={mother}
                      placeholder="Enter mother's name"
                      onChange={(e) => setMother(e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="form-col">
                  <div className="form-group">
                    <label className="form-label">Mother's Caste</label>
                    <input
                      className="form-control"
                      type="text"
                      value={mcaste}
                      placeholder="Enter mother's caste"
                      onChange={(e) => setMcaste(e.target.value)}
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Mother's Kulam</label>
                <input
                  className="form-control"
                  type="text"
                  value={mkulam}
                  placeholder="Enter mother's kulam"
                  onChange={(e) => setMkulam(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-section">
              <div className="form-section-title">Family Details</div>
              <div className="form-row">
                <div className="form-col">
                  <div className="form-group">
                    <label className="form-label">Family Status</label>
                    <select
                      className="form-control"
                      value={fstatus}
                      onChange={(e) => setFstatus(e.target.value)}
                      required
                    >
                      <option value="">Select family status</option>
                      <option value="Middle Class">Middle Class</option>
                      <option value="Upper Middle Class">Upper Middle Class</option>
                      <option value="Rich">Rich</option>
                      <option value="Affluent">Affluent</option>
                    </select>
                  </div>
                </div>
                <div className="form-col">
                  <div className="form-group">
                    <label className="form-label">Family Type</label>
                    <select
                      className="form-control"
                      value={ftype}
                      onChange={(e) => setFtype(e.target.value)}
                      required
                    >
                      <option value="">Select family type</option>
                      <option value="Joint Family">Joint Family</option>
                      <option value="Nuclear Family">Nuclear Family</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Family Values</label>
                <select
                  className="form-control"
                  value={fvalues}
                  onChange={(e) => setFvalues(e.target.value)}
                  required
                >
                  <option value="">Select family values</option>
                  <option value="Orthodox">Orthodox</option>
                  <option value="Traditional">Traditional</option>
                  <option value="Moderate">Moderate</option>
                  <option value="Liberal">Liberal</option>
                </select>
              </div>
            </div>

            <div className="form-section">
              <div className="form-section-title">Siblings Information</div>
              <div className="form-row">
                <div className="form-col">
                  <div className="form-group">
                    <label className="form-label">Number of Sisters</label>
                    <select
                      className="form-control"
                      value={sisters}
                      onChange={(e) => setSisters(e.target.value)}
                      required
                    >
                      <option value="">Select number</option>
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5+">5+</option>
                    </select>
                  </div>
                </div>
                <div className="form-col">
                  <div className="form-group">
                    <label className="form-label">Number of Brothers</label>
                    <select
                      className="form-control"
                      value={brothers}
                      onChange={(e) => setBrothers(e.target.value)}
                      required
                    >
                      <option value="">Select number</option>
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5+">5+</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="form-col">
                  <div className="form-group">
                    <label className="form-label">Married Sisters</label>
                    <select
                      className="form-control"
                      value={msisters}
                      onChange={(e) => setMsisters(e.target.value)}
                      required
                    >
                      <option value="">Select number</option>
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5+">5+</option>
                    </select>
                  </div>
                </div>
                <div className="form-col">
                  <div className="form-group">
                    <label className="form-label">Married Brothers</label>
                    <select
                      className="form-control"
                      value={mbrothers}
                      onChange={(e) => setMbrothers(e.target.value)}
                      required
                    >
                      <option value="">Select number</option>
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5+">5+</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Parents' Contact Number</label>
                <input
                  className="form-control"
                  type="tel"
                  value={parentsno}
                  placeholder="Enter parents' contact number"
                  onChange={(e) => setParentsno(e.target.value.replace(/\D/g, ""))}
                  required
                />
              </div>
            </div>
          </div>

          {/* Form Footer with Buttons */}
          <div className="profile-form-footer">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={() => navigate("/modern-image-upload")}
            >
              Back
            </button>
            <button type="submit" className="btn btn-primary">
              Save & Next
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModernFamilyDetails;
